module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('settings.main.edit_payment_method')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings.label.set_configurations')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._l((_vm.customFields), function(customField) {
    return _c('div', [_c('label', {
      staticClass: "ls-label col-md-6"
    }, [_c('b', {
      staticClass: "ls-label-text"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (customField.value),
        expression: "customField.value"
      }],
      attrs: {
        "type": "text",
        "name": customField.tag
      },
      domProps: {
        "value": (customField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          customField.value = $event.target.value
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('router-link', {
    staticClass: "ls-btn",
    attrs: {
      "to": "/settings/payment_settings/" + _vm.payment.processor + "/show",
      "title": _vm.$t('application.menu.payment_settings')
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.back')))]), _vm._v(" "), _c('a', {
    staticClass: "ls-btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.saveSetting()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.save')))])], 1)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32eb15a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/EditPaymentSettings.vue
// module id = 753
// module chunks = 1